import { ThemeProvider, createTheme } from '@mui/material';
import MaterialTable from 'material-table'
import { useModal } from 'react-hooks-use-modal';
import React, { useEffect, useState } from 'react'
import { useAuth } from "../hooks/use-auth";
import axios from 'axios';
import { Search } from '@mui/icons-material';
import { IconWrapper, ModalStyle, ModalClose } from "styles/styles";

interface Props {
  search: string;
  setSelectedContents: any;
}

const IdSearchButton = ({ search, setSelectedContents }: Props) => {
  //modal
  const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
  //modal end

  const auth = useAuth();

  const defaultMaterialTheme = createTheme();
  const [pageSize, setPageSize] = React.useState(5);

  //arrayの生成
  let parentArray: any = [];
  if (search === "equipments") {
    parentArray = [{ title: '', field: 'equipment_id' },
    { title: '設備ID', field: 'display_id' },
    { title: '正式名', field: 'name' },
    { title: '正式名（カナ）', field: 'name_kana' },
    { title: '略称', field: 'abbreviation' },
    { title: 'メモ', field: 'memo' }]
  } else if (search === "factory-breakings") {
    parentArray = [{ title: '', field: 'factory_breaking_id' },
    { title: '休憩区分ID', field: 'display_id' },
    { title: '開始時間', field: 'start_time' },
    { title: '終了時間', field: 'end_time' }]
  } else if (search === "processes") {
    parentArray = [{ title: '', field: 'process_id' },
    { title: '工程ID', field: 'display_id' },
    { title: '工程名', field: 'name' },
    { title: '', field: 'equipment_id' },
    { title: '設備ID', field: 'equipment_display_id' },
    { title: '設備名称', field: 'equipment_name' },
    { title: '略称', field: 'abbreviation' }]
  } else if (search === "suppliers") {
    parentArray = [{ title: '', field: 'supplier_id' },
    { title: '仕入先', field: 'display_id' },
    { title: '名前', field: 'name' },
    { title: '略称', field: 'abbreviation' }]
  } else if (search === "users") {
    parentArray = [{ title: '', field: 'user_id' },
    { title: 'ユーザーID', field: 'display_id' },
    { title: '氏名', field: 'name' },
    { title: '氏名（カナ）', field: 'name_kana' }]
  } else if (search === "standard-processes") {
    parentArray = [{ title: '', field: 'standard_processes_id' },
    { title: '品番ID', field: 'product_number_display_id', default: '', required: true, disable: true },
    { title: '品番_枝番', field: 'product_number_branch_display_id', default: '', required: true, disable: true },
    { title: '品名', field: 'product_number_branch_name', default: '', search: 'product-numbers', required: true, disable: true },
    { title: '枝番', field: 'display_id' },
    { title: 'メモ', field: 'memo' }]
  }

  let PAGE_TITLE: string;
  switch (search) {
    case "equipments":
      PAGE_TITLE = "設備";
      break;
    case "factory-breakings":
      PAGE_TITLE = "休憩区分";
      break;
    case "processes":
      PAGE_TITLE = "工程";
      break;
    case "suppliers":
      PAGE_TITLE = "仕入先";
      break;
    case "users":
      PAGE_TITLE = "ユーザー";
      break;
    case "standard-processes":
      PAGE_TITLE = "標準工程";
      break;
    default:
      PAGE_TITLE = "キーワードが見つかりません";
  }

  const columnsArray: any = [];
  for (const element of parentArray) {
    if (element.title) {
      columnsArray.push({
        title: element.title,
        field: element.field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        },
      })
    }
  }

  const condition = () => {
    return (
      search === "equipments" ||
      search === "factory-breakings" ||
      search === "processes" ||
      search === "suppliers" ||
      search === "users" ||
      search === "standard-processes"
    );
  }

  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    if (condition()) {
      let uri;
      let params;
      if (search === "users") {
        uri = `/v0/account/users`;
        params = { factory_id: auth.factoryId };
      } else {
        uri = `/v0/factories/${auth.factoryId}/${search}`
        params = {};
      }
      try {
        axios.get(uri, {
          headers: auth.authorizationHeader,
          params: params
        }).then((res: any) => {
          if (res.data.length) {
            if (search === "suppliers") {
              setData(res.data.filter((item: { [key: string]: any }) => parseInt(item["is_linked"]) === 1))
            } else {
              setData(res.data);
            }
          } else {
            setData([]);
          }
        })
      } catch (err) {
        console.log(err)
      }
    }
  }, []);

  /* iconを表示し、押されると、modal内が表示される */
  if (condition()) {
    return (
      <>
        <IconWrapper><Search style={iconStyle} onClick={() => open()} /></IconWrapper>
        <Modal>
          <ModalStyle>
            <ThemeProvider theme={defaultMaterialTheme}>
              <MaterialTable
                title={PAGE_TITLE}
                columns={columnsArray}
                data={data}
                options={{
                  paging: false,
                  headerStyle: { whiteSpace: 'nowrap' },
                  rowStyle: { overflowWrap: 'break-word' }
                }}
                onChangeRowsPerPage={(pageSize) => {
                  setPageSize(pageSize);
                }}
                onRowClick={(event: any, rowData: any) => {
                  event.preventDefault();
                  setSelectedContents(rowData)
                  close();
                }}
              />
            </ThemeProvider>
            <ModalClose onClick={close}>CLOSE</ModalClose>
          </ModalStyle>
        </Modal>
      </>
    )
  } else {
    return (<></>)
  }
}

export default IdSearchButton;

const iconStyle = {
  color: 'white',
  fontSize: ' 22px',
  fontWeight: '700',
  backgroundColor: '#1A4EA1',
  borderRadius: '5px'
}